<script setup lang="ts">
import { currentOrganization } from '@/app'
</script>

<template>
  <router-view v-if="!!currentOrganization" />
</template>
